export default __webpack_public_path__ + "static/trashpile-ed4f256bb509ab9eaf4ee3a507726c62.png";